import { render, staticRenderFns } from "./SelectStudents.vue?vue&type=template&id=1969dd22&scoped=true"
import script from "./SelectStudents.vue?vue&type=script&lang=js"
export * from "./SelectStudents.vue?vue&type=script&lang=js"
import style0 from "./SelectStudents.vue?vue&type=style&index=0&id=1969dd22&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1969dd22",
  null
  
)

export default component.exports